import { IStopArea } from '../../../../../../../models/stop-area.model';
import { t } from '../../../../../../../services/texts.service';
import { Icon } from '../../../../../../Shared/Icon';
import { IconMotif } from '../../../../../../Shared/Icon/icon-motif.enum';
import { IconVariant } from '../../../../../../Shared/Icon/icon-variant.enum';
import { StopAreaType } from '../../../../models/stop-area-type.enum';

export default function StopAreaDescription({ stopAreas, type }: { stopAreas: IStopArea[]; type: StopAreaType }) {
  const homeLabel = t('Hemma', 'Home');
  const workLabel = t('Arbete', 'Work');

  return (
    <div>
      <div className="d-flex align-items-center gap-1">
        <Icon motif={IconMotif.StopArea} variant={IconVariant.Circle} className="align-self-center" />
        <div className="d-flex flex-column">
          {stopAreas.map((stopArea, index) => (
            <span key={`${stopArea.gid}-${index}`}>{stopArea.name}</span>
          ))}
        </div>
      </div>
      <div className="h2 mb-0">{type === StopAreaType.Home ? homeLabel : workLabel}</div>
    </div>
  );
}
